import React, { useEffect, useState } from "react";
import "./admin.css";
import DashTile from "../../components/admin/dashtitle/dahtile";
import { cfo_dash_info, dash_info } from "./admin.api";
import jwtDecode from "jwt-decode";

const routeMapping = {
  "companies-:-kspace-premises": "/company-request-list/kspace",
  "companies-:-own_premises": "/company-request-list/own",
  "existing-kerala-companies-affliated-with-kspace": "/kerala-companies-list",
  "indian-companies": "/india-companies-list",
  "international-companies": "/international-companies-list",
  resource_personal: "/resource-list",
  "expert-manpower": "/manpower-list",
  "technology-transfer": "/transfer-proposal-list",
  "candidate-application": "/academicinstitution-list",
  "project-proposal": "/project-proposal-list",
  "academic-institution": "/academicinstitution-list",
  "academic-project-proposals": "/institutionproposal-list",
  "intership-training": "/intershiptraining-list",
  "spacepark-advisors": "/advisors-list",
  "market-research-:-tender": "/tender-list",
  "market-research-:-trade-enquiries": "/trade-list",
  // "market-research-:-tender": "/trade-list",
  "market-research-:-publications": "/publication-list",
  "jobseeker-registration": "/candidates-list/registry",
  "event-:-registrations": "/event-booking",
  mou: "/admin-mou",
  membership: "/membership",
  faq: "/faq-list",
  vendor: "/vendors-list",
  Publications: "/publication-list",
  advertisement: "/advertisement-list",
  "event-:-kspace-events": "/event-list-kspace",
  "event-:-other-events": "/event-list-others",
  "bulk-emails": "/bulk-emails",
  "challenge-opportunity": "/challenges",

};

export default function Admin(props) {
  const [count, setCount] = useState({});
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const handleEventList = () => {
    if (adminType !== 23) {
      dash_info(adminType).then((res) => {
        let tdata = res.data;
        let formattedData = {};

        Object.keys(tdata).forEach((key) => {
          formattedData[key] = {
            total: tdata[key]?.total || 0,
            pending: tdata[key]?.pending || 0,
          };
        });

        setCount(formattedData);
      });
    } else {
      cfo_dash_info().then((res) => {
        let tdata = res.data;
        let formattedData = {};

        Object.keys(tdata).forEach((key) => {
          formattedData[key] = {
            total: tdata[key]?.total || 0,
            pending: tdata[key]?.pending || 0,
          };
        });

        setCount(formattedData);
      });
    }
  };

  useEffect(() => {
    handleEventList();
  }, []);

  const data = Object.keys(count).map((key) => ({
    label: key.replace(/[-_]/g, " ").toUpperCase(),
    total: count[key]?.total,
    pending: count[key]?.pending,
    link: routeMapping[key] || "#",
  }));
  return (
    <div>
      <div className="admin-dash-data-tiles">
        {data.map((item, index) => (
          <DashTile
            key={index}
            label={item.label}
            pending={item.pending}
            total={item.total}
            link={item.link}
            adminType={adminType}
            {...props}
          />
        ))}
      </div>
    </div>
  );
}
